import { ThemeEvents, VariantUpdateEvent } from "@theme/events";

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  constructor() {
    super();

    this.dynamicPoints =
      this.closest(".product-details")?.querySelector(".dynamic-points");
  }
  connectedCallback() {
    console.log("ProductPrice connected to the DOM");
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.addEventListener(
      ThemeEvents.variantUpdate,
      this.updatePrice,
    );
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    closestSection.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updatePrice,
    );
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    console.log("Received variant update event:", event);
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector(
      'product-price [ref="priceContainer"]',
    );
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }

    // update the dynamic points
    try {
      if (this.dynamicPoints) {
        const text = newPrice.querySelector(".price")?.textContent || "";
        const cleaned = text.replace(/[^0-9.-]/g, "");
        const price = Number(cleaned.replace(/,/g, ""));

        if (price && this.dynamicPoints) {           // repeat check or use local var — both fine
          const ratio = parseFloat(this.dynamicPoints.getAttribute("data-ratio") ?? "1");

          // safe — you just checked this.dynamicPoints is truthy
          this.dynamicPoints.querySelector(".dynamic-points-text").textContent = (price * ratio).toFixed(0);  // ← added .toFixed if you want integer points
        }
      }
    } catch (error) {
      // Consider logging instead of silent catch
      console.warn("Dynamic points update failed", error);
    }
  };
}

if (!customElements.get("product-price")) {
  customElements.define("product-price", ProductPrice);
}
